import React, {useContext, useState, useEffect}  from 'react';
import { ask__ } from '../../shared/utils/i18n.js';
import { GlobalAppointmentContext } from '../../shared/context/GlobalAppointment.js';
import { getLang, isLocalDevelopmentSite } from './../../shared/utils/environment.js';
import { cancelAppointment } from './../../shared/utils/api.js';
import { GlobalErrorContext } from './../../shared/context/GlobalErrorContext.js';

import calendarImage from '../../assets/images/calendar.svg';
import videoImage from '../../assets/images/video.svg';
import phoneImage from '../../assets/images/phone.svg';
import videoOutlineImage from '../../assets/images/video-outline.svg';
import phoneOutlineImage from '../../assets/images/phone-outline.svg';
import locationImage from '../../assets/images/location.svg';

import moment from 'moment/min/moment-with-locales';
import Icon from '../Icon/Icon';
import "./Timeslot.scss";

export default function Timeslot(props) {

  // set date locale
  moment.locale(getLang());

  const {setGlobalError} = useContext(GlobalErrorContext);
  const {setGlobalAppointment} = useContext(GlobalAppointmentContext);

  let className = 'timeslot';
  className += ' timeslot--' + props.type;

  if (props.phase) {
    className += ' timeslot--phase-' + props.phase;
  }

  const [isVideoReceptionOpen, setIsVideoReceptionOpen] = useState(false);
  const [isPastVideReception, setIsPastVideReception] = useState(true);

  // debug opening and closing of videoReception with manual timestamp field

  const [debugVideoReceptionTimestamp, setDebugVideoReceptionTimestamp] = useState(parseFloat(Math.floor(Date.now() / 1000)));
  const [isDebugVideoReceptionTimestamp, setIsDebugVideoReceptionTimestamp] = useState(false);

  const setVideoReceptionsStates = () => {

    // in staging everything is permitted
    if (!window.ortonWebsiteData.env.booking.is_production) {
      setIsVideoReceptionOpen(true);
      setIsPastVideReception(false);
      return;
    }

    if (props.type == 'reservation' && props.isVideoReception) {
      let unixTimeStamp = parseFloat(Math.floor(Date.now() / 1000));
     // DEBUG: TIMESTAMPS
      // if (isDebugVideoReceptionTimestamp) {
      //   unixTimeStamp = debugVideoReceptionTimestamp;
      // }
      const videoReceptionOpens = parseFloat(props.videoReceptionOpens);
      const videoReceptionCloses = parseFloat(props.videoReceptionCloses);
      if (unixTimeStamp >= videoReceptionOpens && unixTimeStamp <= videoReceptionCloses) {
        setIsVideoReceptionOpen(true);
      } else {
        setIsVideoReceptionOpen(false);
      }
      if (unixTimeStamp > videoReceptionCloses) {
        setIsPastVideReception(true);
      } else {
        setIsPastVideReception(false);
      }
    }
  };

  // handle open/close video meeting time
  useEffect(() => {

    // debug
    setIsDebugVideoReceptionTimestamp(isLocalDevelopmentSite());

    setVideoReceptionsStates();
    const timer = setInterval(() => {
      setVideoReceptionsStates();
    }, 1000);
    // clear interval if the component is unmounted
    return () => clearInterval(timer);
  });

  const handleItemClick = (e) => {

    if (e.target === e.currentTarget) {
      e.preventDefault();
      if (props.type == 'booking') {
        handleButtonClick(e);
      }
    }

  };

  const handleButtonClick = (e) => {

    e.preventDefault();
    if (props.type == 'booking') {
      const payload = {
        hasConfirmation: true,
        timeStart: props.timeStart,
        timeDay: props.timeDay,
        timeHour: props.timeHour,
        type: props.timeType,
        duration: props.duration,
        resourcePath: props.resourcePath,
        isVideoReception: props.isVideoReception,
        isPhoneReception: props.isPhoneReception,
        unit: props.unit,
        name: props.name,
        title: props.title,
        legal: props.legal,
        image: props.image,
        locationName: props.locationName,
        locationAddress: props.locationAddress,
        notice: props.notice
      };

      window.sessionStorage.setItem('oa-booking-confirmation', JSON.stringify(payload));
      setGlobalAppointment(payload);

    }

    if (props.type == 'reservation' && props.canCancel) {

      let r = window.confirm(ask__('Booking: Cancel confirm'));
      if (r == true) {
        (async () => {
          try {

            const cancel_is_successful = await cancelAppointment({
              'reservation_path': props.reservationPath,
              'start': props.timeStart,
            });

            if (cancel_is_successful) {
              // fire callback
              if (typeof props.onCancel == "function") {
                props.onCancel(e);
              }
            } else {
              setGlobalError({
                isError: true,
                errorCode: 'RCA300'
              });
            }

            // @todo hook to parent

          } catch(err) {
            console.error(err);
            setGlobalError({
              isError: true,
              errorCode: 'RCA300'
            });
          }

        })();

      }

    }

  };

  const handleDebuggingTimestamp = (e) => {
    setDebugVideoReceptionTimestamp(e.target.value);
  };

  return (
    <div
      onClick={handleItemClick}
      className={className}
      data-starts={props.timeStart}
      data-is-phone-reception={props.isPhoneReception}
      data-video-opens={props.videoReceptionOpens}
      data-video-closes={props.videoReceptionCloses}
    >

      <div className="timeslot__specialist">
        <div className="timeslot__specialist__content">
          {props.image ? <>
            <div className="timeslot__specialist__image">
              <img
                loading="lazy"
                src={props.image}
                width={120}
                height={120}
              />
            </div>
          </> : ''}
          <div className="timeslot__specialist__meta">
            <h2>{props.specialistUrl ? <a target="_blank" href={props.specialistUrl}>{props.name}</a> : props.name}</h2>
            {props.legal ? <span className="timeslot__specialist__legal">{props.legal}</span> : ''}
            {props.title ? <span className="timeslot__specialist__title">{props.title}</span> : ''}
          </div>

        </div>
      </div>

      <div className="timeslot__times">

        {props.type == 'booking' ? <>

          <div className="timeslot__times__brief">
            <span className="timeslot__times__brief__hour">{props.timeHour}</span>
            <span className="timeslot__times__brief__duration">{props.duration} min</span>
          </div>

        </> : ''}

        {props.type == 'confirmation' || props.type == 'reservation'  ? <>

          <div className="timeslot__times__icon">
            <img
              loading="lazy"
              src={calendarImage}
              width={120}
              height={120}
            />
          </div>

          <div className="timeslot__times__content">
            <span className="timeslot__times__date">
              {moment(props.timeDay).format('dd D.M.YYYY')} {ask__('Booking: Hour separator')}&nbsp;{props.timeHour}
            </span>
            <span className="timeslot__times__brief__duration">{props.duration} min</span>
          </div>

        </> : ''}

      </div>

      <div className="timeslot__location">

        {props.type == 'confirmation' || props.type == 'reservation'  ? <>
          <div className="timeslot__location__icon">
            <img
              loading="lazy"
              src={props.isVideoReception ? videoImage : (props.isPhoneReception ? phoneImage : locationImage)}
              width={120}
              height={120}
            />
          </div>
        </> : ''}

        {!props.isVideoReception && !props.isPhoneReception && props.locationName !== '' ? <>
          <div className="timeslot__location__content">
            <span className="timeslot__location__title">
              {props.locationName !== '' ? <>
                {props.locationName}
              </> : ''}
            </span>

            <span className="timeslot__location__address" dangerouslySetInnerHTML={{__html: (props.locationAddress || '')}}>
            </span>
          </div>
        </> : ''}

        {props.isVideoReception ? <>
          <div className="timeslot__location__content">
            <span className="timeslot__location__title">
              {props.type == 'booking' || props.type == 'reservation' ? <>
                <div className="timeslot__location__content__icon">
                  <img
                    loading="lazy"
                    alt=""
                    src={videoOutlineImage}
                    width={60}
                    height={60}
                  />
                </div>
              </> : ''}
              {ask__('Booking: Remote reception')}
            </span>
            <span className="timeslot__location__address" dangerouslySetInnerHTML={{__html: (ask__('Booking: Remote reception desc'))}}></span>
          </div>
        </> : <></>}

        {props.isPhoneReception ? <>
          <div className="timeslot__location__content">
            {/* <span className="timeslot__location__title">
              {ask__('Booking: Phone')}
            </span> */}
            <span className="timeslot__location__address" dangerouslySetInnerHTML={{__html: (ask__('Booking: Phone desc'))}}></span>
          </div>
        </> : <></>}

      </div>

      <div className="timeslot__actions">

      {props.type == 'booking' ? <>

          <button onClick={handleButtonClick} className="timeslot__actions__book">{ask__('Booking: Book now')}</button>
          <Icon name="arrow-outline" />
      </> : ''}

      {/* @todo: hide on old appointments */}
      {props.type == 'reservation' && props.isVideoReception && !isPastVideReception ? <>
        {props.videoReceptionLink ? <>
            <a
            className={isVideoReceptionOpen ? 'timeslot__actions__join-chat timeslot__actions__join-chat--open' : 'timeslot__actions__join-chat timeslot__actions__join-chat--closed'}
            target="_parent"
            onClick={e => {if(!isVideoReceptionOpen) { e.preventDefault(); }}}
            href={isVideoReceptionOpen ? props.videoReceptionLink : ''}
          >
            { ask__('Booking: Remote connect') }
          </a>
          <span className="timeslot__actions__chat-tips">{ ask__('Booking: Remore connect tips') }</span>
        </> : <>
          <span className="timeslot__actions__invalid-ninchat">{ ask__('Booking: Invalid Ninchat link') }</span>
        </>}
      </> : <></>}

      {props.type == 'reservation' && props.canCancel ? <>
        <button onClick={handleButtonClick} className="timeslot__actions__cancel">
          {ask__('Booking: Cancel button')}
          <Icon name="close" />
        </button>
      </> : ''}
      {/* DEBUG: TIMESTAMPS */}
      {/* {props.type == 'reservation' && isDebugVideoReceptionTimestamp ? <>
        <div className="timeslot__debug-timestamp">
          <p>👷‍♂️👷‍♂️ Debug timestamps 👷‍♂️👷‍♂️</p>
          <input onChange={handleDebuggingTimestamp} type="number" value={debugVideoReceptionTimestamp} />
        </div>
      </> : <></> } */}

      </div>

    </div>
  )

}
